import React, { useEffect } from 'react'
import components from '../components'
import screens from '../screens'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'

const MainLayout = () => {
  const role = localStorage.getItem('role');
  const navigate = useNavigate();
  
  console.log('🚀 ~ MainLayout ~ role from localStorage:', role);
  console.log('🚀 ~ MainLayout ~ role type:', typeof role);

  useEffect(() => {
    if (!role) {
      // If the user is not authenticated, navigate to the login page
      navigate('/auth/Login');
    }
  }, [role, navigate]);

  return (
    <>
      <div style={{display:"flex",flexDirection:"row",alignItems:"flex-start",height:'100vh'}}>
        <components.layoutsCommponents.Vertical/>
        <div style={{display:'flex',flexDirection:"column",width:"100%"}}>
          <components.layoutsCommponents.horizontal/>
          <div style={{height:"100vh",maxWidth:"80%",marginLeft:"20%", padding:"0 3rem"}}>
            {role?<Outlet/>:null}
          </div>
        </div>
      </div>
    </>
  )
}

export default MainLayout